import http from '../../HttpConfig'
import { APIS_ENDPOINTS } from '../../SERVICE-CONSTANTS'

const ZamenCheques_endpoints = APIS_ENDPOINTS.requestzamencheques

export interface IZamenChequesCountPayload {
  id: number
  amount: number
  date: string
  requestId: number
  number: number
  IFile: File
  chequesType: number
}

export const request_sendzamenchequescount = async ({
  id,
  amount,
  date,
  requestId,
  number,
  IFile,
  chequesType,
}: {
  id: number
  amount: number
  date: string
  requestId: number
  number: number
  IFile: File
  chequesType: number
}) => {
  const formData = new FormData()
  if (id) {
    formData.append('Id', id.toString())
  }
  formData.append('Amount', amount.toString())
  formData.append('Date', date)
  formData.append('RequestId', requestId.toString())
  if (number) {
    formData.append('Number', number.toString())
  }
  if (IFile) {
    formData.append('IFile', IFile)
  }
  if (chequesType) {
    formData.append('ChequesType', chequesType.toString())
  }
  return http.post(ZamenCheques_endpoints.sendzamencheques, formData)
}

export const request_getallrequestzamencheques = async ({ RequestId }: { RequestId: number }) => {
  return http.get(ZamenCheques_endpoints.getallrequestzamencheques + '?RequestId=' + RequestId)
}

export const request_delete = async ({ id }: { id: number }) => {
  return http.delete(ZamenCheques_endpoints.delete + '?id=' + id)
}

export const request_getAllRequestZamenChequesAdmin = async ({
  search,
  CurrentPage,
  PageSize,
  isMyWork
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  isMyWork: boolean
}) => {
  return http.get(
    ZamenCheques_endpoints.getallrequestzamenchequesadmin +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${isMyWork ? `&IsMyWork=${isMyWork}` : ''}`
  )
}

export const request_detail = async (id: number) => {
  return http.get(ZamenCheques_endpoints.detail + `?id=${id}`)
}


export const request_addnote = async ({ requestZamenChequesId, title, text, file }) => {
  const formData = new FormData();
  formData.append("RequestZamenChequesId", requestZamenChequesId.toString() || "");
  formData.append("Title", title || "");
  formData.append("Text", text || "");
  formData.append("IFile", file || "");
  return http.post(ZamenCheques_endpoints.addrequestzamenchequesnote, formData)
}
export const request_addreference = async ({ requestZamenChequesId, receiverId, receiverRole, title, text, file }) => {
  const formData = new FormData();
  formData.append("RequestZamenChequesId", requestZamenChequesId.toString() || "");
  formData.append("ReceiverId", receiverId || "");
  formData.append("Title", title || "");
  formData.append("Text", text || "");
  formData.append("IFile", file || "");
  formData.append("ReceiverRole", receiverRole || "");
  return http.post(ZamenCheques_endpoints.addreference, formData)
}

export const request_getallletternote = async (RequestId: number) => {
  return http.get(ZamenCheques_endpoints.getallrequestzamenchequesnote + `?RequestId=${RequestId}`)
}

export const request_changeletter = async ({ id, checkStatus }: { id: number, checkStatus: number }) => {
  return http.post(ZamenCheques_endpoints.changerequestzamencheques + `?id=${id}&checkStatus=${checkStatus}`)
}


export const request_archiveletter = async (id: number) => {
  return http.post(ZamenCheques_endpoints.archiverequestzamencheques + `?id=${id}`)
}

export const request_revokeReferral = async ({
  requestZamenChequesId,
  title,
  text,
}: {
  requestZamenChequesId: number,
  title: string,
  text: string,
}) => {
  const formData = new FormData();
  formData.append("RequestZamenChequesId", requestZamenChequesId?.toString() || "");
  formData.append("Title", title || "");
  formData.append("Text", text || "");

  return http.post(ZamenCheques_endpoints.revokereferral, formData)
}

export const request_accept = async (id: number) => {
  return http.post(ZamenCheques_endpoints.requestzamencheques + `?Id=${id}`)
}